import 'bootstrap/dist/js/bootstrap.min';

import './../scss/main.scss';

$( document ).ready( function () {
    // --- Работа с формой обратной связи ---
    var $form = $( '#feedback' );

    $form.find( '.data' ).on( 'change keyup focusout', function() {
        checkForm( $form );
    } );

    $form.on( 'submit', function (event) {
        event.preventDefault();

        if( checkForm( $form ) ) {
            var data = {
                type: $form.find('[name=type]').val(),
                subject: $form.find('[name=subject]').val(),
                to: $form.find('[name=to]').val(),
                fields: {}
            }

            $form.find( '.data' ).each( function() {
                var key = $( this ).attr( 'name' );
                var title = $( this ).parent( '.form-group, .input-group' ).find( 'label' ).html();
                var value = $( this ).val();

                data[ 'fields' ][ key ] = {
                    title: title,
                    value: value
                };
            } );

            $.ajax( '/assets/snippets/feedback/feedback.snippet.php', {
                method : 'POST',
                data : { data: JSON.stringify( data ) },
                beforeSend : function() {
                    $form.find( '.alert' ).hide();
                    $form.find( '.progress-feedback' ).show();
                    $form.find( '[type=submit]' ).removeClass( 'btn-success' ).attr( 'disabled', 'disabled' ).addClass( 'btn-default' );
                },
                complete : function() {
                    $form.find( '.progress-feedback' ).hide();
                    checkForm( $form );
                },
                success : function( answer ) {
                    if( answer == 'Message has been sent' ) {
                        $form.find('.alert-success').show();
                    } else {
                        $form.find('.alert-danger').show();
                    }
                },
                error : function() {
                    $form.find('.alert-danger').show();
                }
            } );
        }
    } );

    function checkForm( $form ) {
        var $requiredField = $form.find( '[required]' );
        var result = true;

        $requiredField.each( function() {
            var value = $( this ).val();

            if( value == '' ) {
                result = false;
            }
        } );

        if( result ) {
            $form.find( '[type=submit]' ).removeClass( 'btn-default' ).removeAttr( 'disabled' ).addClass( 'btn-success' );
        } else {
            $form.find( '[type=submit]' ).removeClass( 'btn-success' ).attr( 'disabled', 'disabled' ).addClass( 'btn-default' );
        }

        return result;
    }
    // --- Конец - Работа с формой обратной связи ---
});